export default "__VITE_ASSET__C4eVRD_q__"